import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import videojs from "video.js";
import CONFIG from "@bd-core/config";
import compile from "@bd-utils/handlerbars-helper";
import BD_Component from "@bd-core/bd-component";
import {
    getRoomStatus,
    getFinalTeamAnswers,
    getTotalAttempt,
    getRoomScore,
    getRoomLogo,
    getCurrentRoomScreen,
    getPlayers,
} from "@bd-stores/game-progress";
import { getRoomAnswerById } from "@bd-stores/game-data";
import {
    saveFinalRoomAnswers,
    maybeUpdateRoomStatus,
    updateRoomAnswer,
    getRoomAnswers,
    setTotalAttempt,
    setRoomTotalScores,
    setTeamLogos,
    updateCurrentScreen,
    setDraggingAttributes,
} from "@bd-core/firebase-actions";
import GameLogic from "@bd-core/game-logic";
import Storage from "@bd-utils/storage";
import { isLeader } from "@bd-stores/game-progress";
import { isTestMode } from "@bd-utils/test-mode";
import fb from "@bd-core/firebase";

export class RoomMatchCard extends BD_Component {
    constructor() {
        super();

        this.id = "match_card";
        this.templateID = "match_card-template";
        this.elms = {
            clearAnswerBtn: ".js-clear-answer",
            submitBtn: ".js-submit",
            crystalWrapper: ".js-crystal",
            correctTxt: ".js-correct",
            totalTxt: ".js-total-card",
            triesTxt: ".js-tries",
            cardsStack: ".js-cards-stack",
            cardItem: ".js-card-item",
            dragDropLayer: ".js-drag-drop-layer",
            dropArea: ".js-drop-area",
            dropContainer: ".js-drop-container",
            dropItem: ".js-drop-item",
            openAllCard: ".js-card-nav-btn",
            closeAllCard: ".js-close-all-card-list",
            nextCardBtn: ".js-next",
            prevCardBtn: ".js-prev",
            cardOnPopup: ".js-card-on-popup",
            searchFindBg: ".js-search-find-bg",
            searchFindBtn: ".js-search-find-button",
            searchFindPopupTitle: ".js-search-find-popup-title",
            challengeTitle: ".js-challenge-title",
            continueBtn: ".js-continue",
            triggerRewardScreenBtn: ".btn-continue-reward-screen",

            // narrative popup
            narrativePopup: ".js-narrative-popup",
            narrativeCloseBtn: ".js-close-narrative-popup",

            // reward screen
            rewardScreen: ".js-reward-feedback",
            rewardTitle: ".js-reward-title",
            rewardSubtitle: ".js-reward-subtitle",
            rewardDescription: ".js-reward-description",
            rewardScore: ".js-reward-score",
            rewardContinueBtn: ".js-reward-continue-btn",

            // customization
            customizationScreen: ".js-customization",
            customRewardWrapper: ".challange-prize__item-wrapper",
            customizationContinueBtn: ".js-customization-continue-btn",
            customizationCategory: ".js-category",
            logoImage: ".js-logo",

            skipVideoBtn: ".js-skip-video"
        };

        this._events = this.getEvents();

        /**
         * @type {BD_RoomMatchCards}
         */
        this._data = undefined;

        this.userAnswer = undefined;

        this.outroVideo = null;

        this.meSubmittingAnswer = false;

        this.fbListeners = [];

        this.isDragging = false;
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.submitBtn,
                handler: this.onSubmitAnswer,
            },
            {
                event: "click",
                selector: elms.clearAnswerBtn,
                handler: this.onClearAnswer,
            },
            {
                event: "click",
                selector: `${elms.openAllCard}, ${elms.closeAllCard}`,
                handler: this.onToggleAllCard,
            },
            {
                event: "click",
                selector: elms.nextCardBtn,
                handler: this.nextCard,
            },
            {
                event: "click",
                selector: elms.prevCardBtn,
                handler: this.prevCard,
            },
            {
                event: "click",
                selector: elms.cardOnPopup,
                handler: this.bringCardToTop,
            },
            {
                event: "click",
                selector: elms.continueBtn,
                handler: this.playOutroVideo,
            },
            {
                event: "click",
                selector: elms.triggerRewardScreenBtn,
                handler: this.playOutroVideo,
            },
            {
                event: "click",
                selector: elms.rewardContinueBtn,
                handler: this.goToCustomizationScreen,
            },
            {
                event: "click",
                selector: elms.customizationContinueBtn,
                handler: this.setSelectedLogo,
            },
            {
                event: "click",
                selector: elms.narrativeCloseBtn,
                handler: this.closeNarrativePopup,
            },
            {
                event: "mousedown",
                selector: "#cards-stack .card-item",
                handler: this.handleCardClick,
            },
            {
                event: "mouseup",
                selector: "#cards-stack .card-item",
                handler: this.handleCardReleaseClick,
            },
            {
                event: "click",
                selector: elms.skipVideoBtn,
                handler: this.skipOutroVideo
            }
        ];
    }

    handleCardClick() {
        setDraggingAttributes(this.roomId, true, CONFIG.user.id);
        this.isDragging = true;
        this.meSubmittingAnswer = true;
    }

    handleCardReleaseClick() {
        const $overlay = $(".general-overlay");
        if ($overlay.hasClass("is-active")) {
            return;
        }

        setDraggingAttributes(this.roomId, false, CONFIG.user.id);
        this.isDragging = false;
        // this.meSubmittingAnswer = false;
    }

    beforeInit() {
        this.render();
        this.setupSlider();
        this.setGameState();
        this.setupDraggable();
        this.setupDroppable();
        this.listenFirebase();
        this.setTestMode();
    }

    getModifiedData() {
        const isTeamLeader = isLeader();
        const roomData = this._data;
        const modifiedData = {
            ...roomData,
            isLeader: isTeamLeader,
        };

        return modifiedData;
    }

    render() {
        const roomData = this.getModifiedData();
        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, roomData);
        $(".app").html(html);
    }

    setTestMode() {
        if (isTestMode()) {
            $(this.elms.submitBtn).addClass("disabled is-completed");
            $(this.elms.crystalWrapper).addClass("hidden");
            $(this.elms.continueBtn).removeClass("disabled hidden");
            $(".app__page").addClass("is-room-completed");
            $(".app__back").removeClass("hidden");
        }
    }

    setGameState() {
        const roomId = this.roomId;
        const thisRoomStatus = getRoomStatus(roomId);
        const roomAnswers = getFinalTeamAnswers(roomId);
        const elms = this.elms;
        // const isTeamLeader = isLeader();

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        /* force players to be on the same screen */
        const currentScreen = getCurrentRoomScreen(roomId);
        const video = videojs.getPlayer("outro-video-match-card");

        switch (currentScreen) {
            //  case "search-find":
            //      $(".narrative-layer").show();
            //      $(".search-and-find-bg").show();
            //      break;
            case "video-outro":
                this.playOutroVideo();
                break;
            case "reward-screen":
                if ((video && video.ended()) || (video && video.paused())) {
                    this.goToRewardScreen();
                }

                break;
            case "customisations-screen":
                this.goToCustomizationScreen();
                break;
            case "puzzle-screen":
                $(".narrative-layer .screen .screen__inner").addClass("enter");
                setTimeout(() => {
                    $(".narrative-layer").css({
                        opacity: 0,
                        "pointer-events": "none",
                    });
                }, 500);
                this.handleBriefingPopup();
                $(".videobox").removeClass("is-open");
                $(elms.rewardScreen).removeClass("active");
                $(elms.customizationScreen).removeClass("active");
                break;
            default:
            //
        }
        /* END: force players to be on the same screen */

        if (roomAnswers) {
            if (thisRoomStatus == "is-status-completed") {
                this.updateUserChoicesList(roomAnswers);
                $(elms.submitBtn).addClass("disabled is-completed");
                $(elms.crystalWrapper).addClass("hidden");
                $(elms.continueBtn).removeClass("disabled hidden");
                $(".app__page").addClass("is-room-completed");
            }
        }

        if (
            thisRoomStatus === "is-status-started" &&
            !this.meSubmittingAnswer
        ) {
            getRoomAnswers(roomId).then((data) => {
                this.updateUserChoicesList(data.val());
            });
        }
    }

    // ============================== CUSTOM FUNCTION
    handleBriefingPopup() {
        let roomId = this.roomId;

        // fix https://www.pivotaltracker.com/story/show/186872215
        if (!isNaN(parseInt(roomId.toString()))) {
            roomId = parseInt(roomId.toString());
        }

        let states = Storage.get("states", {});
        if (!states?.briefing) states.briefing = [];

        if (!states.briefing.includes(roomId)) {
            GameLogic.toggleBriefing();
        }
    }

    onToggleAllCard() {
        $("#allcards").toggle();
    }

    setupSlider() {
        const sliderSourcePopup = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            centerMode: true,

            customPaging: function (slider, i) {
                return "<a>" + (i + 1) + "</a>";
            },
            appendDots: $(".source-popup__nav-item.nav-pagination"),
            prevArrow: $(".source-popup__nav-item.nav-left"),
            nextArrow: $(".source-popup__nav-item.nav-right"),
        };

        const sliderInfoPopup = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            customPaging: function (slider, i) {
                return "<a>" + (i + 1) + "</a>";
            },
            appendDots: $(".msn-popup__nav-item.nav-pagination"),
            prevArrow: $(".msn-popup__nav-item.nav-left"),
            nextArrow: $(".msn-popup__nav-item.nav-right"),
        };

        $(".js-info-slider-wrapper").slick(sliderInfoPopup);
        $(".js-source-wrapper").slick(sliderSourcePopup);
    }

    setupDraggable() {
        const self = this;
        // @ts-ignore
        $("#cards-stack .card-item").draggable({
            containment: ".drag-drop-layer",
            stack: "#drop-area .drop-container .drop-item",
            cursor: "pointer",
            scroll: true,
            revert: function (event) {
                const $this = $(this);

                if (event == false) {
                    $this
                        .removeClass("ui-draggable-dragging")
                        .css("z-index", "");
                }

                $this.data("ui-draggable").originalPosition = {
                    top: 0,
                    left: 0,
                };

                return !event;
            },

            start: function (event, ui) {
                // if (self.isDragging) {
                //     return;
                // }

                // setDraggingAttributes(self.roomId, true, CONFIG.user.id);
                // self.isDragging = true;

                if (ui.helper.closest("#cards-stack").length === 0) {
                    return;
                }

                const $this = $(this);
                ui.helper.data("dropped", false);
                ui.helper.data("id", $this.attr("data-id"));

                // @ts-ignore
                $this.draggable("instance").offset.click = {
                    left: Math.floor(ui.helper.width() / 2),
                    top: Math.floor(ui.helper.height() / 2),
                };
            },

            stop: function (event, ui) {
                const isValidDrop = ui.helper.data("dropped");

                if (
                    !isValidDrop &&
                    ui.helper.closest("#cards-stack").length !== 0
                ) {
                    $(this).removeClass("dropped").css("margin-top", "0px");
                }
                // Check value of ui.helper.data('dropped') and handle accordingly...

                // setDraggingAttributes(self.roomId, false, CONFIG.user.id);
                // self.meSubmittingAnswer = false;

                // fix : dragging state not updated on release card, on `mouseup` event does not triggered when release the card on the edge of screen
                if (self.isDragging) {
                    self.handleCardReleaseClick();
                }

                if (!ui.helper.data("dropped")) {
                    self.meSubmittingAnswer = false;
                }
            },

            drag: function (event, ui) {
                const $overlay = $(".general-overlay");
                if ($overlay.hasClass("is-active")) {
                    ui.helper
                        .draggable("option", "revert", true)
                        .trigger("mouseup");
                    return;
                }
            },
        });
    }

    setupDroppable() {
        const self = this;

        // @ts-ignore
        $("#drop-area .drop-container .drop-item").droppable({
            accept: "#cards-stack .card-item",
            drop: function (event, ui) {
                const $overlay = $(".general-overlay");
                if ($overlay.hasClass("is-active")) {
                    return;
                }
                self.handlerItemDrop(event, ui);
            },
        });
    }

    handlerItemDrop(event, ui) {
        const $this = $(event.target);
        const $dropAreaContainer = $("#drop-area .drop-container");
        const droppedCardId = ui.helper.data("id");

        ui.helper.data("dropped", true);

        $dropAreaContainer
            .find(`.drop-item[data-id="${droppedCardId}"]`)
            .removeAttr("data-id")
            // @ts-ignore
            .droppable("enable");

        $this.attr("data-id", ui.draggable.attr("data-id"));

        // If the card was dropped to the correct slot,
        // position it directly on top of the dashed slot
        // and prevent it being dragged again

        //disable draggable
        ui.draggable.draggable("disable");

        //disable droppable
        // @ts-ignore
        $this.droppable("disable");

        ui.draggable.position({
            of: $this,
            my: "left top",
            at: "left top",
        });

        ui.draggable.addClass("dropped");
        $this.append(ui.draggable);

        //hide thumbnail
        $(`#card-thumbs .card-thumb[data-id="${droppedCardId}"]`).addClass(
            "hidden",
        );

        //update selected item in card list
        const $cardsInCardList = $("#allcard-content .card-item");
        const $mostTopCard = $(
            "#cards-stack .card-items .card-item:last-child",
        );
        const currentCardId = $mostTopCard.attr("data-id");

        $cardsInCardList.removeClass("selected");

        $cardsInCardList
            .filter(`[data-id="${currentCardId}"]`)
            .addClass("selected");
        $(`#allcard-content .card-item[data-id="${droppedCardId}"]`)
            .addClass("inactive")
            .prepend('<div class="selected-label"></div>');

        /* set temp answers */
        const $theYearEl = $this.parents(".drop-container").find(".year");
        const theYear = $theYearEl.attr("data-date");
        this.setTempTeamAnswers(theYear, droppedCardId);
        maybeUpdateRoomStatus(this.roomId, "is-status-started");

        this.toggleCheckButton();
    }

    setTempTeamAnswers(year, cardId) {
        const self = this;
        const answers = {
            [year]: {
                answer: cardId,
                status: "not-checked",
            },
        };

        const roomId = this.roomId;
        // const currentPlayerId = CONFIG.user.id;

        getRoomAnswers(roomId).then((data) => {
            const userAnswer = data.val() ?? {};
            const answerData = { ...userAnswer, ...answers };

            updateRoomAnswer(roomId, answerData)
                .then(() => (self.meSubmittingAnswer = false))
                .catch();
        });
    }

    removeTempTeamAnswers(year) {
        const roomId = this.roomId;

        getRoomAnswers(roomId).then((data) => {
            const userAnswer = data.val();

            delete userAnswer[year]?.answer;
            delete userAnswer[year]?.status;

            updateRoomAnswer(roomId, userAnswer);
        });
    }

    /**
     * Decide whether to disabled or enabled boolean action (Check btn)
     */
    toggleCheckButton() {
        const elms = this.elms;
        const $dropAreaContainer = $("#drop-area .drop-container");
        const $cards = $dropAreaContainer.find(".drop-item[data-id]");
        const timeline = this._data.timeline;
        const timelineLength = Object.values(timeline).length;

        if ($cards.length == timelineLength) {
            $(elms.submitBtn).removeClass("disabled");
        }
    }

    nextCard(e) {
        e.preventDefault();

        const $parent = $("#cards-stack .card-items");
        const $currentCard = $parent.find(".card-item:last-child");
        const $nextCard = $currentCard.prev();
        const nextCardId = $nextCard.attr("data-id");

        if ($parent.children().length <= 1) {
            return false;
        }

        $nextCard
            .hide()
            .appendTo($parent)
            // @ts-ignore
            .effect("slide", { direction: "left" }, "fast", function () {
                $currentCard.prependTo($parent);

                //set the current card placeholder
                const $cardsInCardList = $("#allcard-content .card-item");

                $cardsInCardList.removeClass("selected");
                $cardsInCardList
                    .filter(`[data-id="${nextCardId}"]`)
                    .addClass("selected");
            });
    }

    prevCard(e) {
        e.preventDefault();

        const $parent = $("#cards-stack .card-items");
        const $prevCard = $parent.find(".card-item:first-child");
        const prevCardId = $prevCard.attr("data-id");

        if ($parent.children().length <= 1) {
            return false;
        }

        $prevCard
            .hide()
            .appendTo($parent)
            // @ts-ignore
            .effect("slide", { direction: "right" }, "fast", function () {
                //set the current card placeholder
                const $cardsInCardList = $("#allcard-content .card-item");

                $cardsInCardList.removeClass("selected");
                $cardsInCardList
                    .filter(`[data-id="${prevCardId}"]`)
                    .addClass("selected");
            });
    }

    bringCardToTop(e, $el) {
        if ($el.hasClass("inactive") || $el.hasClass("selected")) {
            return false;
        }

        var cardID = $el.attr("data-id"),
            $targetCardItem = $(
                `#cards-stack .card-items .card-item[data-id="${cardID}"]`,
            );

        $el.parents("#allcards").fadeOut();

        $el.siblings().removeClass("selected");
        $el.addClass("selected");
        $targetCardItem.show().parent().append($targetCardItem);
    }

    calculateScore(totalAttempt) {
        const rewards = this._data.point_earned || [];
        const score = 10;
        // @ts-ignore
        const reward = rewards.find((item) => {
            const level = item.level;
            const attempts = item.total_attempts;

            if (level === "below") {
                return totalAttempt <= attempts;
            }

            if (level === "above") {
                return totalAttempt >= attempts;
            }
        });

        return Number(reward?.points) || score;
    }

    onSubmitAnswer(e, el) {
        const roomId = this.roomId;
        let totalAttempt = getTotalAttempt(roomId);

        const elms = this.elms;
        const $el = $(el);
        const $result = $(elms.crystalWrapper);
        const $continueBtn = $(elms.continueBtn);
        const sttCompleted = "is-status-completed";

        if (
            $el.hasClass("is-loading") ||
            $el.hasClass("is-completed") ||
            sttCompleted === getRoomStatus(roomId)
        ) {
            return;
        }

        $result.removeClass("is-shown");
        $el.addClass("is-loading").prop("disabled", true);

        const roomID = this.roomId;
        const $dropAreaContainer = $("#drop-area .drop-container");
        const roomAnswers = getRoomAnswerById(roomID);

        let teamRegion = CONFIG.game.region;
        teamRegion = teamRegion === "" ? "Global" : teamRegion;
        teamRegion = teamRegion.replaceAll(" ", "_");
        const correctAnswers = roomAnswers?.[teamRegion] || [];

        let roomStatus = "is-status-started";
        let playerAnswers = {};
        let correct = 0;
        let wrong = 0;

        $.each($dropAreaContainer, function (index, item) {
            const date = $(item).find(".year").attr("data-date");
            const cardId = $(item).find(".card-item").attr("data-id");

            playerAnswers = {
                ...playerAnswers,
                [date]: {
                    answer: cardId,
                    status: "not-checked",
                },
            };
        });

        for (const key in playerAnswers) {
            let { answer, status } = playerAnswers[key];
            let answerStatusWrong = "wrong";

            if (correctAnswers[key] === answer) {
                correct++;
                status = "correct";
            } else {
                wrong++;
                status = answerStatusWrong;
            }

            $(`#drop-area .drop-item[data-id="${answer}"]`)
                .parent()
                .removeClass("correct wrong not-checked")
                .addClass(status)
                .prepend(`<div class="check-result ${status} ">`);

            playerAnswers[key] = {
                ...playerAnswers[key],
                status: status,
            };
        }

        totalAttempt++;
        setTotalAttempt(roomId, totalAttempt);

        const isAllCorrect = wrong == 0 && correct > 0;
        const totalCard = Object.values(playerAnswers).length;

        $result.removeClass("hidden");
        $result.find(elms.correctTxt).text(correct);
        $result.find(elms.totalTxt).text(totalCard);
        $result.find(elms.triesTxt).text(totalAttempt);

        $el.removeClass("is-loading").prop("disabled", false);

        if (isAllCorrect) {
            roomStatus = sttCompleted;

            const onSuccess = () => {
                $el.parent().parent().addClass("is-completed");
                $(".app__page").addClass("is-room-completed");
                $el.addClass("disabled");
                $continueBtn.removeClass("disabled hidden");

                /* set score (silicon crytal currency) */
                const playerScore = this.calculateScore(totalAttempt);
                setRoomTotalScores(roomId, playerScore);
            };

            saveFinalRoomAnswers(roomID, playerAnswers)
                .then(onSuccess)
                .catch(() => (this.meSubmittingAnswer = false));
        } else {
            updateRoomAnswer(roomID, playerAnswers);
        }

        maybeUpdateRoomStatus(roomID, roomStatus);
    }

    onClearAnswer(e, $el) {
        e.preventDefault();

        const roomId = this.roomId;
        const roomStatus = getRoomStatus(roomId);

        if (roomStatus === "is-status-completed") return;

        const elms = this.elms;
        const $result = $(elms.crystalWrapper);
        const $card = $el.parents(".card-item");
        const $stacks = $("#cards-stack .card-items");
        const theID = $card.attr("data-id");
        const theYear = $el
            .parents(".drop-container")
            .find(".year")
            .attr("data-date");

        $el.parents(".drop-container")
            .removeClass("correct wrong")
            .find(".check-result")
            .remove();

        $("#do-check").addClass("disabled");

        $(elms.submitBtn).addClass("disabled");

        $(`#drop-area .drop-container .drop-item[data-id="${theID}"]`)
            .removeAttr("data-id")
            // @ts-ignore
            .droppable("enable");

        $card
            .removeClass("dropped")
            .appendTo($stacks)
            .draggable("enable")
            .animate(
                {
                    left: 0,
                    top: 0,
                },
                400,
                function () {
                    //show the thumbnail
                    $(
                        `#card-thumbs .card-thumb[data-id="${theID}"]`,
                    ).removeClass("hidden");

                    //update selected item in card list
                    var $cardsInCardList = $("#allcard-content .card-item");

                    $cardsInCardList.removeClass("selected");

                    $(`#allcard-content .card-item[data-id="${theID}"]`)
                        .addClass("selected")
                        .removeClass("inactive")
                        .find(".selected-label")
                        .remove();
                    $(`#allcard-content .card-item[data-id="${theID}"]`)
                        .siblings()
                        .removeClass("selected");
                },
            )
            .css("z-index", "");

        $result.addClass("hidden");
        this.removeTempTeamAnswers(theYear);
        this.toggleCheckButton();
    }

    dischardUserAnswer(answerId) {
        const roomId = this.roomId;
        const currentPlayerId = CONFIG.user.id;

        getRoomAnswers(roomId).then((data) => {
            const fbRoomAnswers = data.val() ?? {};
            const userAns = fbRoomAnswers[currentPlayerId]?.choice;

            const userAnsw = Object.keys(userAns)
                .filter((answer) => {
                    return userAns[answer] != answerId;
                })
                .reduce((answ, key) => {
                    answ[key] = userAns[key];
                    return answ;
                }, {});

            updateRoomAnswer(roomId, {
                [currentPlayerId]: {
                    user_id: currentPlayerId,
                    choice: userAnsw,
                },
            });
        });
    }

    updateUserChoicesList(answers) {
        const tempAnswers = answers || {};
        const $dropAreaContainer = $("#drop-area .drop-container");
        const elms = this.elms;
        const $submitBtn = $(elms.submitBtn);
        let isAllChecked = true;
        let totalCorrect = 0;

        $.each($dropAreaContainer, function (index, item) {
            // const year = $(item).find(".year").attr("data-year");
            const date = $(item).find(".year").attr("data-date");

            if (tempAnswers[date]) {
                const { answer, status } = tempAnswers[date];
                const cardId = answer;

                if (status === "not-checked") isAllChecked = false;

                if (status === "correct") totalCorrect++;

                const $cardOnStacks = $(
                    `#cards-stack .card-item[data-id="${cardId}"]`,
                );

                const $yearCard = $dropAreaContainer.find(
                    `span[data-date="${date}"]`,
                );
                const $theParent = $yearCard.parent();
                const $theCard = $theParent.find(`.drop-item`);

                $theCard
                    .attr("data-id", cardId)
                    .removeClass("ui-droppable-active")
                    .addClass("ui-droppable-disabled");

                $theCard
                    .parent()
                    .removeClass("correct wrong not-checked")
                    .addClass(status)
                    .prepend(`<div class="check-result ${status} ">`);

                // @ts-ignore
                $cardOnStacks.position({
                    of: $theCard,
                    my: "left top",
                    at: "left top",
                });

                $cardOnStacks.addClass("dropped");
                $theCard.append($cardOnStacks);

                $(`#card-thumbs .card-thumb[data-id="${cardId}"]`).addClass(
                    "hidden",
                );

                //update selected item in card list
                const $cardsInCardList = $("#allcard-content .card-item");
                const $mostTopCard = $(
                    "#cards-stack .card-items .card-item:last-child",
                );
                const currentCardId = $mostTopCard.attr("data-id");

                $cardsInCardList.removeClass("selected");

                $cardsInCardList
                    .filter(`[data-id="${currentCardId}"]`)
                    .addClass("selected");
                $(`#allcard-content .card-item[data-id="${cardId}"]`)
                    .addClass("inactive")
                    .prepend('<div class="selected-label"></div>');
            } else {
                const $removeBtn = $(item).find(".js-clear-answer");

                if ($removeBtn.length) {
                    $removeBtn.trigger("click");
                }
            }
        });

        this.toggleCheckButton();

        const $result = $(elms.crystalWrapper);
        if (isAllChecked && !$submitBtn.hasClass("disabled")) {
            const totalCards = $dropAreaContainer.length;
            const totalAttempts = getTotalAttempt(this.roomId);

            $result.removeClass("hidden");
            $result.find(elms.correctTxt).text(totalCorrect);
            $result.find(elms.totalTxt).text(totalCards);
            $result.find(elms.triesTxt).text(totalAttempts);
        } else if (!isAllChecked) {
            $result.addClass("hidden");
        }
    }

    playOutroVideo() {
        const $outroVideo = $(".videobox");
        const outroVideoUrl = this._data.video_block.video_outro;
        const is_leader = isLeader();

        if (is_leader) updateCurrentScreen(this.roomId, "video-outro");

        if (!$outroVideo.length) {
            this.goToRewardScreen();
            return false;
        }

        let states = Storage.get("states", {});
        let outroStates = states?.outroVideo || [];

        /**
         * check wheiter the video has url or not
         * if no url, close video popup and start room timer
         **/
        if (outroVideoUrl === "false") {
            this.goToRewardScreen();
            return false;
        }

        if (!outroStates.includes(this.roomId)) {
            // init video js with full screen
            const outroVideo = videojs("outro-video-match-card", {
                controls: true,
                autoplay: true,
                preload: "auto",
                sources: [
                    {
                        src: outroVideoUrl,
                        type: "video/mp4",
                    },
                ],
                techOrder: ["html5"],
            });

            // handle on ended video
            outroVideo.on("ended", () => {
                outroVideo.dispose();
                this.afterPlayOutroVideo();
            });

            // handle on error video
            outroVideo.on("error", function () {
                console.error("Can't play the video");
            });

            $outroVideo.addClass("is-open");

            try {
                outroVideo.play().catch((error) => {
                    // Autoplay was blocked. Do something
                    console.error("Unable to start auto play", error);
                    this.afterPlayOutroVideo();
                });
            } catch (error) {
                console.error(error);
            }
        } else {
            this.goToRewardScreen();
        }

        if (isTestMode()) {
            maybeUpdateRoomStatus(this.roomId, "is-status-completed");
        }
    }

    skipOutroVideo() {
        const videos = videojs.getPlayers();
        const outroVideo = videos["outro-video-match-card"];
        
        outroVideo.dispose();
        this.afterPlayOutroVideo();
    }

    afterPlayOutroVideo() {
        const $outroVideo = $(".videobox");
        let states = Storage.get("states", {});
        let outroStates = states?.outroVideo || [];

        if (!outroStates.includes(this.roomId)) {
            outroStates.push(this.roomId);
            states.outroVideo = outroStates;
            Storage.set("states", states);
        }

        $outroVideo.removeClass("is-open");
        this.goToRewardScreen();
    }

    goToRewardScreen() {
        const elms = this.elms;
        const roomId = this.roomId;
        const rewards = this._data.rewards || [];
        const roomScore = getRoomScore(roomId);
        const $rewardPopup = $(elms.rewardScreen);
        const teamname = CONFIG.game.teamname;
        const is_leader = isLeader();
        const $completionPopUp = $(".js-room-completion");
        const $outroVideo = $(".videobox");

        // @ts-ignore
        const reward = rewards.find((item) => roomScore == Number(item.points));

        let title, subtitle, description;

        if (reward?.title) {
            title = reward.title;
            title = title.replaceAll("{team_name}", teamname);
        }

        if (reward?.subtitle) subtitle = reward.subtitle;

        if (reward?.description) description = reward.description;

        $outroVideo.removeClass("is-open");
        $completionPopUp.removeClass("is-open");

        $rewardPopup.addClass("active");
        $rewardPopup.find(elms.rewardTitle).text(title);
        $rewardPopup.find(elms.rewardSubtitle).text(subtitle);
        $rewardPopup.find(elms.rewardDescription).html(description);
        $rewardPopup.find(elms.rewardScore).text(roomScore);

        if (is_leader) updateCurrentScreen(roomId, "reward-screen");

        // hide timer hint popup
        $(".js-popup-timerhint").removeClass("is-open");

        // hide all card wrapper
        $("#allcards").hide();

        // force hide snackbar on the reward screen
        this.hideSnackbarMessage();
    }

    goToCustomizationScreen() {
        const elms = this.elms;
        const roomId = this.roomId;
        const is_leader = isLeader();
        const roomScore = getRoomScore(roomId);
        const $rewardPopup = $(elms.rewardScreen);
        const $customizationPopup = $(elms.customizationScreen);
        const $score = $(elms.rewardScore);
        const $selectedCategory = $(`
            ${elms.customizationCategory}[data-score="${roomScore}"]
        `);

        $(elms.customizationCategory).each(function () {
            const $slider = $(this).find(".challange-prize__item-wrapper");
            const isInitialized = $slider.hasClass("slick-initialized");
            const sliderCustomRewardOption = {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                arrows: true,
                prevArrow: $(this).find(`.challange-prize__item-prev`),
                nextArrow: $(this).find(`.challange-prize__item-next`),
            };

            if (!isInitialized) $slider.slick(sliderCustomRewardOption);
        });

        $selectedCategory.addClass("is-selected");
        $rewardPopup.removeClass("active");
        $customizationPopup.addClass("active");
        $score.text(roomScore);

        if (is_leader) updateCurrentScreen(roomId, "customisations-screen");
    }

    setSelectedLogo() {
        const elms = this.elms;
        const roomId = this.roomId;
        const isTeamLeader = isLeader();
        const roomLogo = getRoomLogo(roomId);
        const roomScore = getRoomScore(roomId);
        const $selectedCategory = $(`
            ${elms.customizationCategory}[data-score="${roomScore}"]
        `);
        const $activeSlide = $selectedCategory.find(".slick-active");
        const $theImg = $activeSlide.find(elms.logoImage);
        const selectedImg = $theImg.attr("data-image");

        // redirect player to mainroom
        const goToMainroom = () => {
            const mainRoomID = CONFIG?.game?.rooms.find(
                (key) => key.id == roomId,
            ).mainroom_id;

            if (isTeamLeader) updateCurrentScreen(roomId, null);
            GameLogic.goToPage(mainRoomID);
        };

        if (roomLogo) goToMainroom();

        if (selectedImg == undefined) {
            goToMainroom();
            return false;
        }

        if (isTeamLeader) {
            setTeamLogos(roomId, selectedImg)
                .then(goToMainroom)
                .catch(goToMainroom);
        } else {
            goToMainroom();
        }
    }

    closeNarrativePopup() {
        GameLogic.toggleNarrative();
    }

    showSnackbarMessage(text) {
        const $snackbar = $(".snackbar");
        const $overlay = $(".general-overlay");

        $snackbar.find(".snackbar__body").html(text);
        $snackbar.addClass("is-active");
        $overlay.addClass("is-active");
    }

    hideSnackbarMessage() {
        const $snackbar = $(".snackbar");
        const $overlay = $(".general-overlay");
        $snackbar.removeClass("is-active");
        $overlay.removeClass("is-active");
    }

    onDraggingStateChange(snapshot) {
        const data = snapshot.val();

        if (data && data.isDragging && data.playerId != CONFIG.user.id) {
            const players = getPlayers();
            const playerName =
                players.find((p) => p.userId == data.playerId)?.name ??
                "Someone";

            const message = CONFIG.strings.playerDragging.replace(
                "{player}",
                playerName,
            );
            this.showSnackbarMessage(message);
            this.isDragging = true;
        } else {
            this.hideSnackbarMessage();
        }
    }

    // onAnswerStateChange(snapshot) {
    //     const data = snapshot.val();

    //     const roomId = this.roomId;
    //     const thisRoomStatus = getRoomStatus(roomId);
    //     if (thisRoomStatus === "is-status-started") {
    //         this.updateUserChoicesList(data);
    //     }
    // }

    listenFirebase() {
        const self = this;

        if (this.fbListeners.length) {
            this.fbListeners.forEach((fn) => fn.call());
        }

        const draggingListener = fb.onValue(
            `${fb.roomsPath}/${self.roomId}/draggingState`,
            self.onDraggingStateChange.bind(this),
        );

        // const answerListener = fb.onValue(
        //     `${fb.roomsPath}/${self.roomId}/answers`,
        //     self.onAnswerStateChange.bind(this),
        // );

        // const totalAttemptListener = fb.onValue(
        //     `${fb.roomsPath}/${self.roomId}/totalAttempt`,
        //     self.onAnswerStateChange.bind(this),
        // );

        this.fbListeners.push(draggingListener);
        // this.fbListeners.push(answerListener);
        // this.fbListeners.push(totalAttemptListener);
    }
}
